import addToCheckedInfoCardData from './add-to-checked-info-card-data';
import removeFromCheckedInfoCardData from './remove-from-checked-info-card-data';

export {addToCheckedInfoCardData, removeFromCheckedInfoCardData};